import { render, staticRenderFns } from "./ExamTable.vue?vue&type=template&id=b3568d74"
import script from "./ExamTable.vue?vue&type=script&lang=js"
export * from "./ExamTable.vue?vue&type=script&lang=js"
import style0 from "./ExamTable.vue?vue&type=style&index=0&id=b3568d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports